import { useState, useEffect } from "react";
import {
    MotifModal,
    MotifModalHeader,
    MotifModalBody,
    MotifModalFooter,
    MotifButton,
    MotifErrorMessage,
} from "@ey-xd/motif-react";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useForm } from "react-hook-form";
import { CaseEditFormType } from "@/type";
import ControlInputBox from "@/features/claimsummary/summary/component/controlInputBox";
import { useTranslation } from "react-i18next";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";

export default function EditCommentModal({
    show,
    setShow,
    comment,
    onSave,
    isEdit,
    updateLoading
}: {
    show: boolean;
    setShow: (isVisible: boolean) => void;
    comment: any;
    onSave: (updatedComment: any) => void;
    isEdit: boolean;
    updateLoading?: boolean;
}) {
    const [showDiscardMessage, setShowDiscardMessage] = useState(false);
    const { t } = useTranslation();

    const { control, handleSubmit, setValue,formState:{errors,isDirty} } = useForm<CaseEditFormType>({
        defaultValues: {
            comment: comment?.commentMsg || "",
        },
    });

    useEffect(() => {
        if (isEdit && comment) {
            setValue("comment", comment?.commentMsg || "");
        }
    }, [comment, isEdit, setValue]);
    const handleSave = (data: any) => {
        const updatedData = {
            commentId: comment.commentId,
            commentMsg: data.comment || "",
        };
        onSave(updatedData);
        setShow(false);
    };
    return (
        <>
            <MotifModal
                show={show}
                onClose={() => {if(isDirty){
                    setShowDiscardMessage(true)
                }else{
                    setShow(false)
                }
            
            }}
                focusTrapOptions={{
                    tabbableOptions: {
                        displayCheck: "none",
                    },
                }}
            >
                <MotifModalHeader>{t("commonComponent.comment.commentEdit.title")}</MotifModalHeader>
                <MotifModalBody>
                    <div className="form-field mar-b-20">
                        <ControlInputBox
                            name={"comment"}
                            control={control}
                            isTextArea={true}
                            label={"commonComponent.comment.commentEdit.label"}
                            showLabel={true}
                            required={true}
                            defaultValue={comment?.commentMsg || ""}
                        />
                    </div>
                    {errors && errors?.comment && errors?.comment?.type==="required"?<MotifErrorMessage>{t("commonComponent.comment.commentEdit.requiredMessage")}</MotifErrorMessage>:<></>}
                </MotifModalBody>
                <MotifModalFooter>
                    <MotifButton variant={CANCEL_BUTTON_VARIANT} onClick={() => {if(isDirty){
                    setShowDiscardMessage(true)
                }else{
                    setShow(false)
                }}}>
                        {t("global.globalActions.cancel")}
                    </MotifButton>
                    <MotifButton
                        variant={SAVE_BUTTON_VARIANT}
                        onClick={handleSubmit(handleSave)}
                        disabled={!comment}
                        loading={updateLoading}
                    >
                        {t("global.globalActions.save")}
                    </MotifButton>
                </MotifModalFooter>
            </MotifModal>

            <ConfirmationModal
                isVisible={showDiscardMessage}
                setIsVisible={setShowDiscardMessage}
                cancelBtnApproveHandler={() => setShow(false)}
                cancelBtnRejectHandler={() => setShowDiscardMessage(false)}
            />
        </>
    );
}
